import React from 'react'
import { ConnectionLineComponentProps } from 'reactflow'
import useConnectionLine from './useConnectionLine'

const ConnectionLine = (props: ConnectionLineComponentProps) => {
  const { path } = useConnectionLine(props)

  return <path fill="none" stroke="red" strokeWidth={2} d={path} />
}

export default ConnectionLine
